import { render } from "./ViewerHeader.vue?vue&type=template&id=fb04db1c"
import script from "./ViewerHeader.vue?vue&type=script&lang=js"
export * from "./ViewerHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrewderse/Documents/repos/gal-scroll-viewer-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__